
<ion-card class="headmodal">
    <span class="titlemodal">
        {{"select_area" | translate}}
    </span>
    <ion-button class="close-button" (click)="modalCtrl.dismiss()">
        <ion-icon color="dark" name="close-outline"></ion-icon>
    </ion-button>
  </ion-card >

<ion-card class="contentcard bg-light">
    <ion-card class="ion-no-margin ion-padding topBar">
        <ion-searchbar (ionInput)="getCityList($event)" (ionClear)="clearCityLists()" showClearButton="always"
            color="light" class="custom">
        </ion-searchbar>
    </ion-card>
    <ion-list *ngIf="citylist?.length > 0" class="ion-padding">
        <ion-item *ngFor="let city of citylist" (click)="selectedCityItem(city)">
            <ion-icon class="inputicon" src="/assets/svg/pin-map.svg"></ion-icon>
            <ng-container *ngIf="platform.isRTL;else ltrShow">
                <ion-label>
                    {{ city.a_title }}
                </ion-label>
            </ng-container>
            <ng-template #ltrShow>
                <ion-label>
                    {{ city.title }}
                </ion-label>
            </ng-template>
        </ion-item>
    </ion-list>
</ion-card>